var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section", attrs: { id: "edit-file-settings" } },
    [
      _c(
        "b-field",
        [
          _c(
            "b-button",
            {
              attrs: { "icon-left": "arrow-left" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v(" Back ")]
          ),
        ],
        1
      ),
      _c("b-loading", {
        attrs: {
          active: _vm.isLoading,
          "is-full-page": false,
          "can-cancel": false,
        },
      }),
      _vm.selectedCustomer
        ? _c("div", [
            _c("header", { staticClass: "modal-card-head" }, [
              _c("p", { staticClass: "modal-card-title" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.selectedCustomer.name) +
                    " - " +
                    _vm._s(_vm.fileSettingsId === "new" ? "New" : "Edit") +
                    " file settings "
                ),
              ]),
            ]),
            _vm.editing
              ? _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [
                    _c("ValidationObserver", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ invalid }) {
                              return [
                                _c(
                                  "form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.saveEdit.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b-field",
                                      { attrs: { label: "File path :" } },
                                      [
                                        _c("b-input", {
                                          attrs: {
                                            name: "filepath",
                                            placeholder: "Enter a filepath",
                                            disabled: "",
                                          },
                                          model: {
                                            value: _vm.editing.filePath,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editing,
                                                "filePath",
                                                $$v
                                              )
                                            },
                                            expression: "editing.filePath",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-field",
                                      { attrs: { label: "Auto import :" } },
                                      [
                                        _c(
                                          "b-checkbox",
                                          {
                                            model: {
                                              value: _vm.editing.active,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editing,
                                                  "active",
                                                  $$v
                                                )
                                              },
                                              expression: "editing.active",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " Import file automatically "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required", slim: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors, valid }) {
                                              return [
                                                _c(
                                                  "b-field",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "Destination table :",
                                                      type: {
                                                        "is-danger": errors[0],
                                                        "is-success": valid,
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "b-select",
                                                      {
                                                        attrs: {
                                                          name: "table",
                                                          placeholder:
                                                            "Select a table",
                                                          expanded: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editing.table,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editing,
                                                              "table",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editing.table",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.movementTables,
                                                        function (table) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              key:
                                                                "table-" +
                                                                table,
                                                              domProps: {
                                                                value: table,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    table
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required", slim: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors, valid }) {
                                              return [
                                                _c(
                                                  "b-field",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "Date format (e.g. DD/MM/YYYY):",
                                                      type: {
                                                        "is-danger": errors[0],
                                                        "is-success": valid,
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("b-input", {
                                                      attrs: {
                                                        name: "dateformat",
                                                        placeholder:
                                                          "Enter a date format",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editing
                                                            .dateFormat,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editing,
                                                            "dateFormat",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editing.dateFormat",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c(
                                      "b-field",
                                      { attrs: { label: "Force time :" } },
                                      [
                                        _c(
                                          "b-checkbox",
                                          {
                                            model: {
                                              value: _vm.editing.ifForceTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editing,
                                                  "ifForceTime",
                                                  $$v
                                                )
                                              },
                                              expression: "editing.ifForceTime",
                                            },
                                          },
                                          [_vm._v(" Force time ")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.editing.ifForceTime
                                      ? _c(
                                          "b-field",
                                          {
                                            attrs: {
                                              label:
                                                "Forced integration time :",
                                            },
                                          },
                                          [
                                            _c("b-timepicker", {
                                              attrs: {
                                                placeholder:
                                                  "Click to select...",
                                                icon: "clock",
                                              },
                                              model: {
                                                value: _vm.editing.forcedTime,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editing,
                                                    "forcedTime",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editing.forcedTime",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required", slim: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors, valid }) {
                                              return [
                                                _c(
                                                  "b-field",
                                                  {
                                                    attrs: {
                                                      label: "Format :",
                                                      type: {
                                                        "is-danger": errors[0],
                                                        "is-success": valid,
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "b-select",
                                                      {
                                                        attrs: {
                                                          name: "parser",
                                                          placeholder: "Parser",
                                                          expanded: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editing.parser,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editing,
                                                              "parser",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editing.parser",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "csv",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " csv / txt "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "edi",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " EDI GoodYear "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required", slim: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors, valid }) {
                                              return [
                                                _vm.editing.parser === "csv"
                                                  ? _c(
                                                      "b-field",
                                                      {
                                                        attrs: {
                                                          label: "Delimiter",
                                                          type: {
                                                            "is-danger":
                                                              errors[0],
                                                            "is-success": valid,
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("b-input", {
                                                          attrs: {
                                                            name: "delimiter",
                                                            placeholder:
                                                              "CSV Delimiter",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.editing
                                                                .delimiter,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.editing,
                                                                "delimiter",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "editing.delimiter",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c(
                                      "b-field",
                                      { attrs: { label: "Header :" } },
                                      [
                                        _c(
                                          "b-checkbox",
                                          {
                                            model: {
                                              value: _vm.editing.header,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editing,
                                                  "header",
                                                  $$v
                                                )
                                              },
                                              expression: "editing.header",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " File has a header (the first line isn't data) "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("hr"),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "is-small",
                                          type: "is-primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.editing.fields.push({
                                              field: "",
                                              fields: "",
                                            })
                                          },
                                        },
                                      },
                                      [_vm._v(" Add field ")]
                                    ),
                                    _vm.editing.table
                                      ? _c(
                                          "b-table",
                                          {
                                            attrs: { data: _vm.editing.fields },
                                          },
                                          [
                                            _c("b-table-column", {
                                              attrs: { label: "Field name" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            attrs: {
                                                              rules: "required",
                                                              slim: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function ({
                                                                    errors,
                                                                    valid,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "b-field",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: {
                                                                                "is-danger":
                                                                                  errors[0],
                                                                                "is-success":
                                                                                  valid,
                                                                              },
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-select",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  name:
                                                                                    "field " +
                                                                                    (props
                                                                                      .row
                                                                                      .index +
                                                                                      1) +
                                                                                    " in table " +
                                                                                    _vm
                                                                                      .editing
                                                                                      .table,
                                                                                  placeholder:
                                                                                    "Select a field",
                                                                                  expanded:
                                                                                    "",
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    props
                                                                                      .row
                                                                                      .name,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        props.row,
                                                                                        "name",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "props.row.name",
                                                                                },
                                                                            },
                                                                            _vm._l(
                                                                              _vm.currentMovementFields,
                                                                              function (
                                                                                field
                                                                              ) {
                                                                                return _c(
                                                                                  "option",
                                                                                  {
                                                                                    key:
                                                                                      "sap-field-" +
                                                                                      field,
                                                                                    domProps:
                                                                                      {
                                                                                        value:
                                                                                          field,
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          field
                                                                                        ) +
                                                                                        " "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("b-table-column", {
                                              attrs: {
                                                label: "Field position",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            attrs: {
                                                              rules: props.row
                                                                .isForced
                                                                ? ""
                                                                : "required",
                                                              slim: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function ({
                                                                    errors,
                                                                    valid,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "b-field",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: {
                                                                                "is-danger":
                                                                                  errors[0],
                                                                                "is-success":
                                                                                  valid,
                                                                              },
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-input",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  name:
                                                                                    "column fields " +
                                                                                    (props
                                                                                      .row
                                                                                      .index +
                                                                                      1) +
                                                                                    " in table " +
                                                                                    _vm
                                                                                      .editing
                                                                                      .table,
                                                                                  disabled:
                                                                                    props
                                                                                      .row
                                                                                      .isForced,
                                                                                  placeholder:
                                                                                    "Column fields",
                                                                                  type: "number",
                                                                                  min: "1",
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    props
                                                                                      .row
                                                                                      .position,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        props.row,
                                                                                        "position",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "props.row.position",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _vm.editing.parser === "edi"
                                              ? _c("b-table-column", {
                                                  attrs: {
                                                    label: "Field length",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (props) {
                                                          return [
                                                            _c(
                                                              "ValidationProvider",
                                                              {
                                                                attrs: {
                                                                  rules:
                                                                    "required",
                                                                  slim: "",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          errors,
                                                                          valid,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "b-field",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    type: {
                                                                                      "is-danger":
                                                                                        errors[0],
                                                                                      "is-success":
                                                                                        valid,
                                                                                    },
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "b-input",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        name:
                                                                                          "field length " +
                                                                                          (props
                                                                                            .row
                                                                                            .index +
                                                                                            1) +
                                                                                          " in table " +
                                                                                          _vm
                                                                                            .editing
                                                                                            .table,
                                                                                        placeholder:
                                                                                          "Field Length",
                                                                                        type: "number",
                                                                                        min: "1",
                                                                                        disabled:
                                                                                          props
                                                                                            .row
                                                                                            .isForced,
                                                                                      },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          props
                                                                                            .row
                                                                                            .length,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              props.row,
                                                                                              "length",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "props.row.length",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                })
                                              : _vm._e(),
                                            _c("b-table-column", {
                                              attrs: { label: "Operator" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c(
                                                          "b-field",
                                                          [
                                                            _c(
                                                              "b-select",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    !props.row
                                                                      .hasWhereClause,
                                                                  name:
                                                                    "where clause operator " +
                                                                    (props.row
                                                                      .index +
                                                                      1) +
                                                                    " in table " +
                                                                    _vm.editing
                                                                      .table,
                                                                  placeholder:
                                                                    "Choose one",
                                                                  type: "text",
                                                                },
                                                                model: {
                                                                  value:
                                                                    props.row
                                                                      .whereClauseOperator,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        props.row,
                                                                        "whereClauseOperator",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "props.row.whereClauseOperator",
                                                                },
                                                              },
                                                              [
                                                                _c("option", [
                                                                  _vm._v("="),
                                                                ]),
                                                                _c("option", [
                                                                  _vm._v("!="),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c("span", [
                                                              props.row
                                                                .whereClauseOperator
                                                                ? _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "button is-danger",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            props.row.whereClauseOperator =
                                                                              null
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              icon: "ban",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("b-table-column", {
                                              attrs: { label: "Field value" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c(
                                                          "b-field",
                                                          [
                                                            _c("b-input", {
                                                              attrs: {
                                                                name:
                                                                  "where clause " +
                                                                  (props.row
                                                                    .index +
                                                                    1) +
                                                                  " in table " +
                                                                  _vm.editing
                                                                    .table,
                                                                disabled:
                                                                  !props.row
                                                                    .hasWhereClause,
                                                                placeholder: "",
                                                                type: "text",
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .whereClause,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "whereClause",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.whereClause",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("b-table-column", {
                                              attrs: { label: "Action" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c(
                                                          "b-field",
                                                          [
                                                            _c(
                                                              "b-select",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    !props.row
                                                                      .hasWhereClause,
                                                                  name:
                                                                    "Where clause action " +
                                                                    (props.row
                                                                      .index +
                                                                      1) +
                                                                    " in table " +
                                                                    _vm.editing
                                                                      .table,
                                                                  placeholder:
                                                                    "Choose one",
                                                                },
                                                                model: {
                                                                  value:
                                                                    props.row
                                                                      .whereClauseAction,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        props.row,
                                                                        "whereClauseAction",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "props.row.whereClauseAction",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        "ignore",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Ignore "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("span", [
                                                              props.row
                                                                .whereClauseAction
                                                                ? _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "button is-danger",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            props.row.whereClauseAction =
                                                                              null
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              icon: "ban",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("b-table-column", {
                                              attrs: { label: "Forced value" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            attrs: {
                                                              rules: props.row
                                                                .isForced
                                                                ? "required"
                                                                : "",
                                                              slim: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function ({
                                                                    errors,
                                                                    valid,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "b-field",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: {
                                                                                "is-danger":
                                                                                  errors[0],
                                                                                "is-success":
                                                                                  valid,
                                                                              },
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-input",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  name:
                                                                                    "field forced value " +
                                                                                    (props
                                                                                      .row
                                                                                      .index +
                                                                                      1) +
                                                                                    " in table " +
                                                                                    _vm
                                                                                      .editing
                                                                                      .table,
                                                                                  disabled:
                                                                                    !props
                                                                                      .row
                                                                                      .isForced,
                                                                                  placeholder:
                                                                                    "Forced Value",
                                                                                  min: "1",
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    props
                                                                                      .row
                                                                                      .force,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        props.row,
                                                                                        "force",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "props.row.force",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("b-table-column", {
                                              attrs: { label: "Force" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c(
                                                          "b-field",
                                                          [
                                                            _c("b-checkbox", {
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .isForced,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "isForced",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.isForced",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("b-table-column", {
                                              attrs: {
                                                label: "Integration criteria",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c(
                                                          "b-field",
                                                          [
                                                            _c("b-checkbox", {
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .hasWhereClause,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "hasWhereClause",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.hasWhereClause",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("b-table-column", {
                                              attrs: { label: "Delete" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (props) {
                                                      return [
                                                        _c("b-button", {
                                                          attrs: {
                                                            type: "is-danger",
                                                            "icon-left":
                                                              "trash-alt",
                                                            size: "is-small",
                                                            rounded: "",
                                                            outlined: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.editing.fields.splice(
                                                                props.index,
                                                                1
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("template", { slot: "empty" }, [
                                              _c(
                                                "section",
                                                { staticClass: "section" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "content has-text-grey has-text-centered",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        [
                                                          _c("b-icon", {
                                                            attrs: {
                                                              icon: "frown",
                                                              size: "is-large",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c("p", [
                                                        _vm._v("Nothing here."),
                                                      ]),
                                                      _c("p", [
                                                        _vm._v(
                                                          "Please note that if one of 'Operator' or 'Action' fields is empty, the integration criteria will be disabled"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _c("hr"),
                                    _c(
                                      "b-field",
                                      {
                                        attrs: {
                                          grouped: "",
                                          position: "is-centered",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "control" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  "icon-left": "save",
                                                  type: "is-primary",
                                                  loading: _vm.isSaving,
                                                  disabled: invalid,
                                                  "native-type": "submit",
                                                },
                                              },
                                              [_vm._v(" Save ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1346212867
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }